import { render, staticRenderFns } from "./BotaoAdicionar.vue?vue&type=template&id=4d392012"
import script from "./BotaoAdicionar.vue?vue&type=script&lang=js"
export * from "./BotaoAdicionar.vue?vue&type=script&lang=js"
import style0 from "./BotaoAdicionar.vue?vue&type=style&index=0&id=4d392012&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports